import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-35">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.3
      }} className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-37">
          <div className="flex items-center justify-between p-6 border-b border-sage-100 sticky top-0 bg-white rounded-t-2xl" data-id="element-38">
            <h2 className="text-2xl font-bold text-charcoal" data-id="element-39">{title}</h2>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-sage-50 transition-colors" data-id="element-40">
              <X className="w-5 h-5 text-charcoal-light" data-id="element-41" />
            </button>
          </div>
          <div className="p-6 text-charcoal-light leading-relaxed space-y-4" data-id="element-42">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-charcoal text-white py-10" data-id="element-43">
        <div className="max-w-4xl mx-auto px-6 flex flex-col items-center gap-4" data-id="element-44">
          <p className="text-sm text-white/50" data-id="element-45">
            Guía Inteligente de Suplementos &copy; {new Date().getFullYear()}
          </p>
          <div className="flex items-center gap-6" data-id="element-46">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-white/70 hover:text-white underline underline-offset-4 decoration-white/30 hover:decoration-white transition-colors" data-id="element-47">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-48">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-white/70 hover:text-white underline underline-offset-4 decoration-white/30 hover:decoration-white transition-colors" data-id="element-49">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-white/40 max-w-xl text-center mt-2" data-id="element-50">
            Este producto no sustituye el consejo médico profesional. Consulta
            siempre a tu médico antes de comenzar cualquier régimen de
            suplementación.
          </p>
        </div>
      </footer>

      {activeModal === 'privacy' && <Modal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-51">
          <p data-id="element-52">
            <strong data-id="element-53">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-54">
            Tu privacidad es importante para nosotros. Esta política describe
            cómo recopilamos, usamos y protegemos tu información personal.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-55">
            Información que recopilamos
          </h3>
          <p data-id="element-56">
            Al realizar tu compra, recopilamos únicamente la información
            necesaria para procesar tu pedido: nombre, correo electrónico y
            datos de pago. Los datos de pago son procesados de forma segura por
            nuestro proveedor de pagos y nunca son almacenados en nuestros
            servidores.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-57">
            Uso de la información
          </h3>
          <p data-id="element-58">
            Utilizamos tu información exclusivamente para: entregar el producto
            digital adquirido, enviarte comunicaciones relacionadas con tu
            compra y, si lo autorizas, enviarte contenido informativo sobre
            salud y suplementación.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-59">
            Protección de datos
          </h3>
          <p data-id="element-60">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            alteración o destrucción.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-61">Tus derechos</h3>
          <p data-id="element-62">
            Puedes solicitar en cualquier momento el acceso, rectificación o
            eliminación de tus datos personales.
          </p>
        </Modal>}

      {activeModal === 'terms' && <Modal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-63">
          <p data-id="element-64">
            <strong data-id="element-65">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-66">
            Al adquirir la Guía Inteligente de Suplementos, aceptas los
            siguientes términos y condiciones.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-67">
            Producto digital
          </h3>
          <p data-id="element-68">
            Este es un producto digital (PDF) de acceso inmediato. Una vez
            completada la compra, recibirás acceso instantáneo al contenido.
            Debido a la naturaleza digital del producto, no se aceptan
            devoluciones una vez descargado.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-69">
            Uso del contenido
          </h3>
          <p data-id="element-70">
            El contenido de esta guía es para uso personal y educativo. Queda
            prohibida su reproducción, distribución o reventa sin autorización
            expresa.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-71">
            Descargo de responsabilidad
          </h3>
          <p data-id="element-72">
            La información contenida en esta guía tiene fines educativos y no
            constituye consejo médico. Siempre consulta a un profesional de la
            salud antes de iniciar, modificar o suspender cualquier régimen de
            suplementación.
          </p>
          <h3 className="text-lg font-bold text-charcoal mt-4" data-id="element-73">
            Propiedad intelectual
          </h3>
          <p data-id="element-74">
            Todo el contenido, diseño y estructura de la Guía Inteligente de
            Suplementos está protegido por derechos de autor. Todos los derechos
            reservados.
          </p>
        </Modal>}
    </>;
}